module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.open) ? _c('div', {
    staticClass: "keyShortcuts"
  }, [_c('div', {
    staticClass: "overlay"
  }), _c('div', {
    staticClass: "inside",
    on: {
      "click": _vm.toggleOpen
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('keyshortcuts.title')))]), _c('p', [_vm._v(_vm._s(_vm.$t('keyshortcuts.subtitle')))]), _c('table', _vm._l((_vm.keys), function(label, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._l((_vm.keyParts(key)), function(k, i) {
      return [_c('div', {
        staticClass: "key"
      }, [_vm._v(_vm._s(_vm.withMetaKey(k)))]), (i < _vm.keyParts(key).length - 1) ? _c('span', {
        staticClass: "and"
      }, [_vm._v("+")]) : _vm._e()]
    })], 2), _c('td', [_vm._v(_vm._s(_vm.$t('keyshortcuts.' + label + '.' + _vm.clean(key))))])])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44385762","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KeyShortcuts/keyshortcuts.vue
// module id = 1257
// module chunks = 1